const loadDataset = (path, cb) => {
  fetch(`/trainingData/${path}`)
    .then(res => res.json())
    .then(json => cb(json))
}

export { loadDataset }